export default function SeoMeta() {
  const siteTitle = "Hochdruckreinigung & Gartenpflege in Havixbeck | Münsterland Industrieservice UG";
  const siteDescription = "Münsterland Industrieservice UG in Havixbeck: Umweltfreundliche Hochdruck- & Steinreinigung ohne Chemie sowie professionelle Gartenpflege & Hausmeisterservice im Münsterland.";
  const siteUrl = "https://muensterland-industrieservice.com/";
  const ogImageUrl = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/hochdruckreinigung_gartenpflege_havixbeck.png";
  return <section id="seometa" className="hidden" aria-hidden="true">
      {}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={siteDescription} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="language" content="de, en" />
      <link rel="canonical" href={siteUrl} />

      {}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:site_name" content="Münsterland Industrieservice UG" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:locale:alternate" content="en_US" />

      {}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={ogImageUrl} />
    </section>;
}